// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".automated-link[data-v-f3785ce0]{margin-bottom:30px}.automated-link a[data-v-f3785ce0]{font-weight:700;font-size:19px;line-height:27px}", ""]);
// Exports
module.exports = exports;
